<template>
  <div class="pages user_information_list">
    <div class="container">
      <p><strong>个人信息收集清单</strong></p>
      <p>
        熊猫绘画尽全力保护您的个人信息安全，并保障您的个人信息处理中的权益。您可以查看对您个人信息的收集、使用情况。
      </p>
      <p><strong>用户资料</strong></p>
      <table class="sdk-table">
        <thead>
          <tr>
            <th>信息名称</th>
            <th>使用目的</th>
            <th>使用场景</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>昵称</td>
            <td>创建账号</td>
            <td>用户编辑资料</td>
          </tr>
          <tr>
            <td>手机号码</td>
            <td>创建账号/登录/管理账号</td>
            <td>注册账号/使用一键登录功能/绑定手机号</td>
          </tr>
          <tr>
            <td>性别</td>
            <td>资料信息</td>
            <td>编辑个人资料</td>
          </tr>
          <tr>
            <td>地区</td>
            <td>资料信息</td>
            <td>编辑个人资料</td>
          </tr>
          <tr>
            <td>头像</td>
            <td>展示</td>
            <td>编辑个人资料</td>
          </tr>
        </tbody>
      </table>
      <p><strong>用户身份信息</strong></p>
      <table  class="sdk-table">
        <thead>
          <tr>
            <th>信息名称</th>
            <th>使用目的</th>
            <th>使用场景</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>账号</td>
            <td>创建账号、登录</td>
            <td>创建账号、登录</td>
          </tr>
          <tr>
            <td>真实姓名</td>
            <td>实名认证/提现</td>
            <td>集市申请卖家资格/钱包提现/认证</td>
          </tr>
          <tr>
            <td>身份证号码</td>
            <td>实名认证</td>
            <td>集市申请卖家资格/认证</td>
          </tr>
          <tr>
            <td>身份证照片</td>
            <td>实名认证</td>
            <td>集市申请卖家资格/认证</td>
          </tr>
        </tbody>
      </table>
      <p><strong>设备信息</strong></p>
      <table  class="sdk-table">
        <thead>
          <tr>
            <th>信息名称</th>
            <th>使用目的</th>
            <th>使用场景</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>IMEI</td>
            <td>安全运行与风控验证</td>
            <td>APP安全运行与风控验证</td>
          </tr>
          <tr>
            <td>Android ID</td>
            <td>安全运行与风控验证</td>
            <td>APP安全运行与风控验证</td>
          </tr>
          <tr>
            <td>OAID</td>
            <td>安全运行与风控验证</td>
            <td>APP安全运行与风控验证</td>
          </tr>
          <tr>
            <td>IDFA</td>
            <td>安全运行与风控验证</td>
            <td>APP安全运行与风控验证</td>
          </tr>
          <tr>
            <td>操作系统版本号</td>
            <td>安全运行与风控验证</td>
            <td>APP安全运行与风控验证</td>
          </tr>
          <tr>
            <td>产品版本号</td>
            <td>安全运行与风控验证</td>
            <td>APP安全运行与风控验证</td>
          </tr>
          <tr>
            <td>硬件序列号</td>
            <td>安全运行与风控验证</td>
            <td>APP安全运行与风控验证</td>
          </tr>
          <tr>
            <td>IP地址</td>
            <td>安全运行与风控验证</td>
            <td>APP安全运行与风控验证</td>
          </tr>
          <tr>
            <td>设备型号和名称</td>
            <td>安全运行与风控验证/兼容性判断</td>
            <td>APP安全运行与风控验证/APP功能兼容性判断</td>
          </tr>
          <tr>
            <td>设备GSM网络类型</td>
            <td>安全运行与风控验证/兼容性判断</td>
            <td>APP安全运行与风控验证/APP功能兼容性判断</td>
          </tr>
          <tr>
            <td>网络运营商</td>
            <td>登录</td>
            <td>使用一键登录</td>
          </tr>
          <tr>
            <td>设备制造商</td>
            <td>兼容性判断</td>
            <td>APP功能兼容性判断</td>
          </tr>
          <tr>
            <td>设备分辨率</td>
            <td>兼容性判断</td>
            <td>APP功能兼容性判断</td>
          </tr>
          <tr>
            <td>蓝牙</td>
            <td>链接外设硬件</td>
            <td>快捷键设置</td>
          </tr>
        </tbody>
      </table>
      <p><strong>服务内容信息</strong></p>
      <table  class="sdk-table">
        <thead>
          <tr>
            <th>信息名称</th>
            <th>使用目的</th>
            <th>使用场景</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>订单信息</td>
            <td>交易记录</td>
            <td>集市购买商品</td>
          </tr>
          <tr>
            <td>支付账号</td>
            <td>支付</td>
            <td>购买商品或会员服务</td>
          </tr>
          <tr>
            <td>问题反馈记录</td>
            <td>与开发人员反馈使用问题或建议</td>
            <td>问题反馈</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserInformationList",
  components: {},
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss">
.user_information_list {
  .container {
    font-size: 14px;
    h1 {
      font-size: 24px;
    }
    .top__desc {
      font-size: 14px;
      text-indent: 2em;
      line-height: 2;
    }
    h6.subtitle {
      font-size: 14px;
      font-weight: normal;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .third-url-list {
      > a {
        display: block;
      }
    }
    li {
      > h2 {
        display: inline;
        font-size: 14px;
        font-weight: bold;
        + ol {
          margin-top: 15px;
        }
      }
      p {
        margin-top: 1em;
        margin-bottom: 0;
      }
    }
  }
  p {
    margin-top: 1em;
    margin-bottom: 0;
    line-height: 2;
  }
  a {
    // display: block;
    word-break: break-all;
    color: #1989fa;
    text-decoration: none;
  }
  .sdk-table {
    color: #646466;
    font-size: 14px;
    border-spacing: 0;
    border: 1px solid #ebeef5;
    table-layout: fixed;
    // width: 100%;
    line-height: normal;
    text-indent: initial;
    text-align: center;
    tr {
      > th {
        padding: 8px 10px;
        border-bottom: 1px solid #d9d9db;
        // &:first-child,
        // &:last-child {
        //   width: 80px;
        // }
      }
    }
    th,
    td {
      box-sizing: border-box;
      font-weight: normal;
      border-bottom: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
    }
    td {
      padding: 10px 8px;
      vertical-align: middle;
      text-align: left;
    }
  }
}
</style>
